var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.061,
    height: 28.796,
    viewBox: "0 0 38.061 28.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-622.471 -2435.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M657.387,2436.015l-.027-.027-.009.009a4.56,4.56,0,0,0-1.951-.447H627.6a4.607,4.607,0,0,0-1.785.359l-.048-.046-.143.148a4.626,4.626,0,0,0-2.656,4.172v18.531a4.638,4.638,0,0,0,4.632,4.633h27.8a4.638,4.638,0,0,0,4.633-4.633v-18.53A4.627,4.627,0,0,0,657.387,2436.015Zm-2.746,2.623L642.8,2450.175a1.718,1.718,0,0,1-2.357,0l-11.831-11.535Zm.759,21.619H627.6a1.546,1.546,0,0,1-1.544-1.544v-18.254l12.23,11.925a4.806,4.806,0,0,0,6.673,0l11.981-11.677v18.005A1.545,1.545,0,0,1,655.4,2460.258Z",
    fill: "#232323",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.aa02eaf191003812035dfb9a89fb79eb.svg";
export { ForwardRef as ReactComponent };